var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"user-actions_navigation",attrs:{"grow":"","color":"grey darken-4","slider-color":"cyan lighten-2"}})}
var staticRenderFns = []

export { render, staticRenderFns }